export const initialProducts = {
    products: [],
    loader: false,
    wishlist: [],
    cart: []
  };